const LS_KEY = "debug:console";

type MutedMethod =
    | "log"
    | "info"
    | "debug"
    | "trace"
    | "group"
    | "groupCollapsed"
    | "groupEnd"
    | "time"
    | "timeLog"
    | "timeEnd"
    | "count"
    | "countReset"
    | "table";

const METHODS_TO_MUTE: MutedMethod[] = [
    "log",
    "info",
    "debug",
    "trace",
    "group",
    "groupCollapsed",
    "groupEnd",
    "time",
    "timeLog",
    "timeEnd",
    "count",
    "countReset",
    "table",
];

const originalConsole: Partial<Record<MutedMethod, Function>> = {};

function muteConsole() {
    METHODS_TO_MUTE.forEach((method) => {
        if (!originalConsole[method]) {
            originalConsole[method] = console[method];
        }
        console[method] = () => {};
    });
}

function restoreConsole() {
    METHODS_TO_MUTE.forEach((method) => {
        if (originalConsole[method]) {
            console[method] = originalConsole[method] as any;
        }
    });
}

function isEnabled(): boolean {
    if (import.meta.env.DEV) return true;
    return localStorage.getItem(LS_KEY) === "1";
}

export function installConsoleGate() {
    if (!isEnabled()) {
        muteConsole();
    }

    (window as any).enableLogs = () => {
        localStorage.setItem(LS_KEY, "1");
        restoreConsole();
        console.warn("Logs ENABLED");
    };

    (window as any).disableLogs = () => {
        localStorage.removeItem(LS_KEY);
        muteConsole();
        console.warn("Logs DISABLED");
    };
}
